import { render, staticRenderFns } from "./EntryTypeCreate.vue?vue&type=template&id=2521ead6&scoped=true"
import script from "./EntryTypeCreate.vue?vue&type=script&lang=js"
export * from "./EntryTypeCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2521ead6",
  null
  
)

export default component.exports